import { LoginHelpModalComponent } from './components/login_help_modal/login_help_modale_controller';
import { LoginHelpModalService } from './services/login_help_modal_service';
import { AccountModel } from './models/account_model';
import { MemberConfigurationDatastore } from './datastore/member_configuration_datastore';
import { AccountStatusDatastore } from './datastore/account_status_datastore';
import { AccountIdentityDatastore } from './datastore/account_identity_datastore';
import { AuthenticationConfiguration } from './configuration/authentication_configuration';
import { AccountTokenServant } from './servants/account_token_servant';
import { AuthTypeEnum } from './types/auth_type_enum';
import { RenderTypeEnum } from './types/render_type_enum';
import { LoginConfigModel } from './models/login_config_model';

require('./vendor.ts');

angular
  .module('data-ng-authentication', ['utility-ng-interface', 'utility-ng-enumeration'])
  .provider('authenticationConfiguration', AuthenticationConfiguration)
  .constant('AuthTypeEnum', AuthTypeEnum)
  .constant('RenderTypeEnum', RenderTypeEnum)
  .service('ngLoginHelpModalService', LoginHelpModalService)
  .value('ngAccountTokenServant', AccountTokenServant)
  .component('loginHelpModal', new LoginHelpModalComponent())
  .factory('ngMemberConfigurationDatastore', (Interface: any) => new MemberConfigurationDatastore(Interface))
  .factory('MemberConfigurationDatastore', (Interface: any) => new MemberConfigurationDatastore(Interface))
  .factory('ngAccountStatusDatastore', (Interface: any) => new AccountStatusDatastore(Interface))
  .factory('ngAccountIdentityDatastore', (Interface: any) => new AccountIdentityDatastore(Interface))
  .service(
    'accountModel',
    function (
      Interface: any,
      ngAccountStatusDatastore: AccountStatusDatastore,
      ngAccountIdentityDatastore: AccountIdentityDatastore
    ) {
      return new AccountModel(Interface, ngAccountStatusDatastore, ngAccountIdentityDatastore);
    }
  )
  .service(
    'loginConfigModel',
    function (
      Interface: any,
      ngMemberConfigurationDatastore: MemberConfigurationDatastore,
      ngAccountStatusDatastore: AccountStatusDatastore
    ) {
      return new LoginConfigModel(Interface, ngMemberConfigurationDatastore, ngAccountStatusDatastore);
    }
  );

require('./core.ts');

export * from './commands/activate_user_activity_command';
export * from './commands/load_account_command';
export * from './commands/login_command';
export * from './commands/login_config_command';
export * from './commands/logout_command';
export * from './commands/reset_account_command';
export * from './commands/reset_member_configuration_command';
export * from './commands/synchronize_deprecated_models_command';
export * from './components/login_help_modal/login_help_modale_controller';
export * from './configuration/authentication_configuration';
export * from './datastore/account_identity_datastore';
export * from './datastore/account_status_datastore';
export * from './datastore/member_configuration_datastore';
export * from './models/account_model';
export * from './models/login_config_model';
export * from './queries/authentication_query_model';
export * from './queries/url_query_model';
export * from './queries/user_activity_activation_query';
export * from './servants/account_token_servant';
export * from './services/login_help_modal_service';
export * from './types/auth_type_enum';
export * from './types/render_type_enum';
export const authenticationData = 'data-ng-authentication';



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/main.ts